import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import groq from 'groq';
import {
  BANNER,
  querySingletonDoc,
  SEO,
  TESTIMONIAL_GROUP_BLOCK,
} from 'lib/queries';
import { client } from 'lib/sanity';
import type { TestimonialsPage } from 'types/cms/pages/TestimonialsPage';

type TestimonialsPageQuery = UseQueryResult & {
  data: TestimonialsPage;
};

export const TESTIMONIALS_PAGE_KEY = 'testimonialsPage';

export const fetchTestimonials = async () => {
  const query = groq`
    ${querySingletonDoc('timeline_testimonials', 'testimonials')} {
      ${SEO},
      title,
      blocks[] {
        _key,
        _ref,
        _type,
        ${TESTIMONIAL_GROUP_BLOCK}
      },
      banner {
        ${BANNER}
      }
    }
	`;

  const response: TestimonialsPage = await client.fetch(query);
  return response;
};

export const useTestimonials = () =>
  useQuery({
    queryKey: [TESTIMONIALS_PAGE_KEY],
    queryFn: fetchTestimonials,
  }) as TestimonialsPageQuery;
